import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-wide"><path d="M6.75 19.25V8.75H21.25V19.25H6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 15.25H2.75V4.75H17.25V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlidesWide;
